import { formatISO } from "date-fns";
import { ReportFormat } from "@common/helpers/reports";
import { CheckDetailGroupBy } from "@common/types/reports/check-detail";
import {
    AccountingReportType,
    ACCOUNTING_REPORT_LABELS,
} from "@common/types/reports/report-type";
import { CheckDetailColumn } from "@common/types/views/checkDetailView";
import { exportCheckDetail } from "@api/accountingReports.api";
import { AccountingReportFilters } from "@components/accounting/types";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";

interface UseCheckDetailDownloadParams {
    filters: AccountingReportFilters;
    entityIds: number[];
    groupBy: CheckDetailGroupBy;
    columns: CheckDetailColumn[];
}

export function useCheckDetailDownload({
    filters,
    entityIds,
    groupBy,
    columns,
}: UseCheckDetailDownloadParams) {
    return useFileDownload(async (format: ReportFormat) => {
        const response = await exportCheckDetail({
            filters,
            entityIds,
            format,
            groupBy,
            columns,
        });
        if (!response || !filters.startDate || !filters.endDate) {
            return;
        }

        const reportTypeTitle =
            ACCOUNTING_REPORT_LABELS[AccountingReportType.CHECK_DETAIL];
        const startLabel = formatISO(filters.startDate, {
            representation: "date",
        });
        const endLabel = formatISO(filters.endDate, {
            representation: "date",
        });
        const fallbackName = `${reportTypeTitle} - ${startLabel} - ${endLabel}.${format}`;

        saveBlobResponse(response, fallbackName);
    });
}
